<template>
<m-pageframe
    title="Search Rest API Reference"
>
<v-container
    fluid
>

    <v-text-field
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
        autofocus
        autocomplete="off"
    >
        <!--<v-menu
            bottom
            offset-y
            slot="append-outer"
        >
            <template v-slot:activator="{ on }">
                <v-icon
                    v-on="on"
                >
                    mdi-dots-vertical
                </v-icon>
            </template>
    
            <v-list>
                <v-list-item
                    v-on:click="onClickDoSomething()"
                >
                    <v-list-item-title>Do Something...</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu> -->
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.some_field="{ item }">
            {{item.some_field}}
        </template>
    
    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Method', value: 'method'},
                { text: 'Path', value: 'path'},
                { text: 'Class', value: 'java_class_simple_name'},
                { text: 'Method', value: 'java_method_name'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest(
                'LIST: /api/v1/rest-reference/endpoints',
            
                {
                    'full_text' : this.full_text,
                },
            
                (data) => {
                    this.results = data.results;
                },
            
                () => {
                    this.$rc.alert('Error','Unable to search rest api reference');
                },
            );
        },
        
    },

}
</script>

<style lang="scss" scoped>
</style>